const Client = require("../modules/ModHttpsClient")

module.exports = {
    load(url){
        return Client.get([
            {
                key: "url",
                value: url
            }
        ],{
            path: "/client/config/load"
        })
    }
}